import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { openConfirmation } from 'helpers/Confirmation';
import Paper from '@material-ui/core/Paper';
import { compose, withHandlers, withState } from 'recompose';
import { withAppContext } from '@ctsu/loader';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setProtocol, setProtocolSync } from 'actions/protocols';
import { bindLogger } from 'helpers/BindLogger';
import Elements from 'ctsutheme/components/atoms';
import { GetFromCtxValue } from 'helpers';
import { httpStatusEnum } from 'appconstants';
import DocumentAutoComplete from 'containers/protocol/components/DocumentAutoComplete';
import { closeModal } from 'actions/common';

const { Button } = Elements;

const styles = theme => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center'
  },
  input: {
    marginLeft: 8
  },
  iconButton: {
    padding: 10
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4
  }
});

const SyncProtocol = ({
  classes, state, handleInputChange, syncProtocol
}) => (
  <div style={{ paddingTop: '1rem', paddingBottom: '20vh' }}>
    <Paper className={`rounded ${classes?.root}`} variant="outlined" >
      <DocumentAutoComplete onChange={handleInputChange} />
      <Button
        variant="outlined"
        size="small"
        data-id="syncPrt"
        className={state && "turquoise"}
        color="primary"
        disabled={state ? state.length === 0 : true}
        onClick={() => syncProtocol()}
      >
          Go
      </Button>
    </Paper>
  </div>
);

const withConnectState = connect(
  (state, ownProps) => ({}),
  dispatch => bindActionCreators(
    {
      onSetProtocolSync: setProtocolSync,
      onSetProtocol: setProtocol,
      onCloseModal: closeModal
    },
    dispatch
  )
);

const ProtocolSync = withStyles(styles)(
  compose(
    withState('state', 'setState', null),
    withConnectState,
    withAppContext,
    withHandlers({
      handleInputChange: props => docNum => {
        const { setState } = props;
        setState(docNum);
      },
      syncProtocol: props => event => {
        const tab = '/protocoldetail';
        const {
          context, state, onSetProtocolSync, onSetProtocol, onCloseModal
        } = props;
        const confirmRedirect = () => {
          onCloseModal();
          onSetProtocol({ id: state, tab });
        };
        bindLogger(onSetProtocolSync, context)(state).subscribe(resp => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            openConfirmation({
              message: GetFromCtxValue(context, 'PROTOCOL_SYNC_SUCCEESS'),
              onAction: confirmRedirect,
              name: 'protocol_sync'
            });
          }
        });
      }
    })
  )(SyncProtocol)
);

export default ProtocolSync;
